import { getValueFromLocalStorage } from '../helpers/utils';

export const initialData = () => ({
  userInfo: {},
  sideNav: {
    collapsed: localStorage.getItem('side-nav-collapsed') == 'true',
    data: getValueFromLocalStorage('sidenav'),
    activeItem: {
      id: null,
      name: null,
      activeSubMenu: {
        id: null,
        name: null,
      },
    },
  },
  notificationSideBar: {
    data: null,
    unseen: 0,
  },
  dataGrid: {
    filters: [],
    actions: [],
    columns: [],
    searchQuery: {
      fields: [],
      filters: [],
      paging: {
        pageIndex: 0,
        pageSize: 10,
      },
      sorting: {},
    },
    items: [],
    properties: {},
    total: 0,
  },
});

export default {
  appSettings: {
    color: 'green-sys',
    size: 'big-sys',
    scheme: 'dark-sys',
  },
  userInfo: initialData().userInfo,
  sideNav: initialData().sideNav,
  notificationSideBar: initialData().notificationSideBar,
  dataGrid: initialData().dataGrid,
  flatDataGrids: getValueFromLocalStorage('grids', true),
  appLoader: {
    visibility: false,
    color: '#009587',
  },
  overlayLoader: { visibility: false },
  breadcrumbs: {
    activeItem: null,
    params: {},
    data: [],
  },
  dynamicForms: [],
  dynamicGrids: [],
  pickLists: [],
};
